import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';

const NavBar = () => {
  const { currentUser, signOut } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };
  
  return (
    <nav className="bg-blue-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <span className="font-bold text-xl">Sismo Struct RD</span>
            </Link>
            
            {currentUser && (
              <div className="ml-10 flex items-baseline space-x-4">
                {/* Agrega aquí más links según los componentes que tengas disponibles */}
              </div>
            )}
          </div>
          
          <div className="flex items-center">
            {currentUser ? (
              <div className="flex items-center space-x-4">
                <span className="text-sm">
                  {currentUser.displayName || currentUser.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="px-3 py-2 rounded-md text-sm font-medium bg-red-500 hover:bg-red-600"
                >
                  Cerrar Sesión
                </button>
              </div>
            ) : (
              <div className="space-x-2">
                <Link
                   to="/login"
                   className="px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700"
                >
                  Iniciar Sesión
                </Link>
                <Link
                   to="/registro"
                   className="px-3 py-2 rounded-md text-sm font-medium bg-blue-500 hover:bg-blue-600"
                >
                  Registrarse
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;